import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { persistStore, persistReducer } from 'redux-persist'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import { createFilter } from 'redux-persist-transform-filter'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'

import { Reducers } from './rootReducers'
import rootSaga from './rootSagas'

const savePlanCpfServicesFilter = createFilter(
  'planCpfServices',
  ['services'],
)

const savePlanCnpjServicesFilter = createFilter(
  'planCnpjServices',
  ['services'],
)

const persistConfig = {
  storage,
  key: 'bgc_motor@3948284',
  stateReconciler: autoMergeLevel2,
  whitelist: [
    'auth',
    'organization',
    'planCnpjServices',
    'planCpfServices',
    'user',
    'config',
  ],
  // blacklist: [],
  transforms: [
    savePlanCnpjServicesFilter,
    savePlanCpfServicesFilter,
  ],
}

const sagaMiddleware = createSagaMiddleware()
const middlewares = [thunk, sagaMiddleware]

const persistedReducer = persistReducer(persistConfig, Reducers)
const store = createStore(
  persistedReducer,
  process.env.NODE_ENV === 'development'
    ? composeWithDevTools(applyMiddleware(...middlewares))
    : applyMiddleware(...middlewares),
)

const persistor = persistStore(store)
sagaMiddleware.run(rootSaga)

export { store, persistor }
